module.exports = __webpack_public_path__ + "img/not_found.9a9678df.png";